import React, { useEffect, useState } from 'react'
import CustomCalendar from '../../../Components/CustomCalendar'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Table from '../../../Components/Table';
import { getTimesheets, updateTimesheet } from '../../../Services/TimeSheet/action';
import { connect } from 'react-redux';
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { exportData } from '../../../Lib/exportData';
import { updateTask } from '../../../Services/Task/action';

const header = [
    { field: "checkbox" },
    { field: "Id" },
    { field: "Code" },
    { field: "Task" },
    { field: "Employee" },
    { field: "Start Time" },
    { field: "End Time" },
    { field: "Total Hours" },
    { field: "Action" },
];

function EmployeeTimeSheet(props) {
    const [selectFilters, setSelectedFilters] = useState({
        Employee: "",
        Search: "",
        Data: "",
    });
    const [data, setData] = useState([]);
    const [activeButton, setActiveButton] = useState("");
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const { employeeId } = useParams();

    const navigate = useNavigate();
    const location = useLocation();
    const locationData = location?.state?.data?.allData;
    const [filteredData, setFilteredData] = useState([]);

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.TimeSheet,
        Featur_Name: FeaturesList.View,
    });

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.TimeSheet,
        Featur_Name: FeaturesList.Update,
    });

    const fetchData = async () => {
        try {
            await props?.getTimesheets();
        } catch (error) {
            console.error("Error fetching timesheets:", error);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    const calculateElapsedWithPauses = (startTimeStr, actionHistory = []) => {
        let totalSeconds = 0;
        let currentStart = new Date(startTimeStr);
        let isRunning = true;

        const sortedHistory = [...actionHistory].sort(
            (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
        );

        for (const action of sortedHistory) {
            const actionTime = new Date(action.timestamp);

            if (action.action === "pause" && isRunning) {
                totalSeconds += Math.floor((actionTime - currentStart) / 1000);
                isRunning = false;
            } else if (action.action === "resume" && !isRunning) {
                currentStart = actionTime;
                isRunning = true;
            } else if (action.action === "stop" && isRunning) {
                totalSeconds += Math.floor((actionTime - currentStart) / 1000);
                isRunning = false;
            }
        }

        if (isRunning) {
            totalSeconds += Math.floor((new Date() - currentStart) / 1000);
        }

        return totalSeconds;
    };

    useEffect(() => {
        setData(
            props?.timesheet
                ?.filter(item => {
                    const userTimerMatch = item?.task?.taskTimerMap?.find(timer =>
                        timer?.employee_id == employeeId &&
                        (location.pathname == `/employees/view/${employeeId}/task/timesheet` ? timer?.task_id == locationData?.id : true) &&
                        timer?.start_time?.split(' ')[0] === item?.start_date?.split(' ')[0] &&
                        timer?.start_time?.split(' ')[1] === item?.start_time
                    );
                    return userTimerMatch;
                })
                ?.map((item) => {
                    const allTimers = item?.task?.taskTimerMap || [];
                    const taskDate = item?.start_date?.split(' ')[0];

                    let totalElapsedTime = 0;
                    let totalHoursLogged;
                    allTimers.forEach((timer) => {
                        const timerDate = timer?.start_time?.split(' ')[0];

                        if (timerDate === taskDate &&
                            (item?.start_time == timer?.start_time?.split(' ')[1]) &&
                            timer?.start_time) {
                            if (timer?.duration && item?.end_time) {

                                const [hh, mm, ss] = timer.duration
                                    .split(/[hms\s]+/)
                                    .filter(Boolean)
                                    .map(Number);
                                totalElapsedTime += (hh * 3600 + mm * 60 + ss);
                            } else {
                                const actionHistory = typeof timer.action_history === "string"
                                    ? JSON.parse(timer.action_history)
                                    : timer.action_history || [];

                                const seconds = calculateElapsedWithPauses(timer.start_time, actionHistory);
                                totalElapsedTime += seconds;
                            }
                        }
                    });


                    const totalH = Math.floor(totalElapsedTime / 3600);
                    const totalM = Math.floor((totalElapsedTime % 3600) / 60);
                    const totalS = totalElapsedTime % 60;
                    totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;
                    return {
                        checkbox: {
                            value: item?.id,
                            value2: item?.task?.taskTimerMap?.find(timer => timer?.state != "stopped")?.id,
                            type: 'checkbox',
                        },
                        Id: {
                            value: item?.id,
                            type: 'text'
                        },
                        "Code": {
                            value: `CD_${item?.id}`,
                            type: 'text'
                        },
                        "Task": {
                            value: item?.memo,
                            type: 'text'
                        },
                        "Employee": {
                            value: item?.task?.taskUserMap?.filter(item => item?.userTaskMap?.id == employeeId)?.[0]?.userTaskMap?.name || "",
                            src: item?.task?.taskUserMap?.filter(item => item?.userTaskMap?.id == employeeId)?.[0]?.userTaskMap?.profile_pic?.data || '',
                            value2: item?.task?.taskUserMap?.filter(item => item?.userTaskMap?.id == employeeId)?.[0]?.userTaskMap?.designation?.name || "",
                            type: 'client'
                        },
                        "Start Time": {
                            value: `${item?.start_date?.split(' ')?.[0]} ${item?.start_time}` || "--",
                            type: 'text'
                        },
                        "End Time": {
                            value: item?.end_time ? item?.end_date ? `${item?.end_date?.split(' ')?.[0]} ${item?.end_time}` : `${item?.start_date?.split(' ')?.[0]} ${item?.end_time}` : "Active",
                            type: 'text'
                        },
                        "Total Hours": {
                            value: totalHoursLogged,
                            type: "text",
                        },
                        Action: {
                            value2: location.pathname == `/employees/view/${employeeId}/task/timesheet` ? `/employees/view/${employeeId}/task/timesheet/view` : `/employees/view/${employeeId}/timesheet/view`,
                            value: location.pathname == `/employees/view/${employeeId}/task/timesheet` ? `/employees/view/${employeeId}/task/timesheet/edit` : `/employees/view/${employeeId}/timesheet/edit`,
                            IsStopTimer: item?.end_time ? false : true,
                            showIsEdit: canEdit && item?.end_time ? true : false,
                            value9: "",
                            type: 'action'
                        },
                        allData: {
                            ...item
                        },
                    }
                })
        )
    }, [props?.timesheet]);

    const handleClick = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const applyFilters = ({ startDate, endDate, search }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = data?.filter((timesheet) => {
            let matchesSearch = true;
            let matchesDate = true;

            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                const itemStartDate = moment(timesheet?.allData?.start_date, 'YYYY-MM-DD HH:mm:ss').startOf('day');
                const itemDueDate = timesheet?.allData?.end_date
                    ? moment(timesheet?.allData?.end_date, 'YYYY-MM-DD HH:mm:ss').startOf('day')
                    : itemStartDate;


                const filterStart = moment(filteredStartDate || startDate, 'DD-MM-YYYY').startOf('day');
                const filterEnd = moment(filteredEndDate || endDate, 'DD-MM-YYYY').endOf('day');

                matchesDate =
                    itemStartDate.isBetween(filterStart, filterEnd, undefined, '[]') ||
                    itemDueDate.isBetween(filterStart, filterEnd, undefined, '[]');
            }
            if (search) {
                matchesSearch = timesheet?.Task?.value?.toLowerCase()?.includes(search?.toLowerCase());
            }
            return matchesSearch && matchesDate;
        });
        setFilteredData(filtered);
    };

    const handleClear = () => {
        setSelectedFilters({
            Search: ""
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    const searchFiled = (e) => {
        const { name, value } = e.target;
        setSelectedFilters((preVal) => ({
            ...preVal,
            [name]: value
        }))
        setSearchTerm(value);
        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, search: value });
    }

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleExportClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));
        try {
            if (type === 'export') {
                setExportLoading(true);
                handleXlsxDownload(ids);
                toast.success('Exported Successfully');
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
        }
    };

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox', 'Action'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = data
            .filter(item => Ids.includes(item.allData?.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (key === 'Employee' && Array.isArray(cell.value)) {
                        newRow[label] = cell.value.map(person => person.name).join(', ');
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });

        exportData({
            data: selectedData,
            columns,
            fileName: 'Timesheet_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };


    return (
        <div className='task-viewEmployee-main mb-5'>
            <div className='row'>
                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="card-type">
                        <CustomCalendar
                            inData={data}
                            searchTerm={searchTerm}
                            setFilteredData={setFilteredData}
                            applyFilters={(params) => { applyFilters(params) }}
                            startDate={filteredStartDate}
                            endDate={filteredEndDate}
                            setStartDate={setFilteredStartDate}
                            setEndDate={setFilteredEndDate} />
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className="input-group">
                        <input
                            type="text"
                            className="input-css"
                            name='search'
                            placeholder='Search...'
                            onChange={searchFiled}
                        />
                    </div>
                </div>


                <div className='col-lg-12 col-md-12  attandance-btn'>
                    <div>
                        <RoleWiseFeatureWrapper
                            modules={props?.modules}
                            features={props?.features}
                            user={props?.user}
                            ModuleName={ModulesList.TimeSheet}
                            Featur_Name={FeaturesList.Create}>

                            <button
                                className="export-btn"
                                id="exportBtn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    location.pathname == `/employees/view/${employeeId}/task/timesheet` ? navigate(`/employees/view/${employeeId}/task/timesheet/add`, { state: { data: { allData: { task_id: locationData?.id } } } }) : navigate(`/employees/view/${employeeId}/timesheet/add`)
                                }}
                            >Log Time</button>
                        </RoleWiseFeatureWrapper>

                        <button
                            className="export-btn"
                            id="exportBtn"
                            disabled={totalSelectedIds.length <= 0 || exportLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleExportClick(totalSelectedIds, 'export');
                            }}
                        >
                            {exportLoading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    className="custom-spinner"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                'Export'
                            )}
                        </button>

                        {(searchTerm || filteredData?.length > 0 || dateStatus) && (
                            <button
                                className="export-btn"
                                disabled={props.loading}
                                onClick={handleClear}
                            >
                                {props.loading ? (
                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                ) : (
                                    'Clear'
                                )}
                            </button>
                        )}
                    </div>
                </div>

                <div className=' col-lg-12 col-md-12'>
                    <>
                        <div className='ticket-table col-lg-12 col-md-12 col-sm-12'>
                            <Table
                                loading={props?.loading}
                                header={header}
                                data={(searchTerm || dateStatus) ? filteredData : data}
                                footer={true}
                                showIsView={canView}
                                // showIsEdit={canEdit}
                                totalSelectedIds={totalSelectedIds}
                                handleChange={handleChange}
                                count={data.length}
                                records={data.length}
                                user={props?.user}
                                updateTask={props?.updateTask}
                            />
                        </div>
                    </>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.timesheetReducer.loading,
        timesheet: state.timesheetReducer.timesheet,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTimesheets: () => {
            dispatch(getTimesheets());
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTimeSheet);